import React, {useRef, useState} from 'react';
import styles from './MultiSelect.module.scss';
import OutsideClickHandler from 'react-outside-click-handler/esm/OutsideClickHandler';
import {ClearIcon, ExpandIcon} from 'components/common/icons';
import cn from 'classnames';
import {Scrollbars} from 'react-custom-scrollbars-2';
import _ from 'lodash';
import {useTranslation} from 'react-i18next';

const MultiSelect = ({
    label,
    placeholder,
    options,
    selected,
    onChange,
    error,
    labelClassName,
    optionsClassName,
    onBlur: blur,
    halfSize,
    getName,
}) => {
    const [isFocused, setFocus] = useState(false);
    const [visibleOptions, setVisibleOptions] = useState(false);
    const [value, setValue] = useState('');
    const inputRef = useRef();
    const {t} = useTranslation();
    const onFocus = () => {
        setFocus(true);
        setVisibleOptions(true);
    };

    const onBlur = () => {
        setFocus(false);
        inputRef.current.blur();
        setValue('');
        setVisibleOptions(false);
        blur();
    };

    const labelWrapper = cn(styles.label, labelClassName, {
        [styles.primary]: isFocused,
        [styles.labelError]: error,
        [styles.filledLabel]: !!selected.length,
    });
    const optionsWrapper = cn(styles.options, optionsClassName, {[styles.visible]: visibleOptions});
    const previewButtonClassName = cn(styles.previewButton, {[styles.opened]: isFocused});
    const inputWrapper = cn(styles.inputRow, {[styles.halfSize]: halfSize});
    const selectedWrapper = cn(styles.selectedWrapper, {[styles.halfSize]: halfSize});

    const filteredOptions = options.filter(option => {
        const regex = new RegExp(value, 'ig');
        return !selected.includes(option.value) && regex.test(option.label);
    });

    return (
        <div className={styles.multiSelect}>
            {label && <div className={labelWrapper}>{label}</div>}
            <OutsideClickHandler onOutsideClick={onBlur}>
                <div className={inputWrapper}>
                    <input
                        value={value}
                        onChange={e => setValue(e.target.value)}
                        onFocus={onFocus}
                        placeholder={placeholder}
                        ref={inputRef}
                    />
                    <ExpandIcon className={previewButtonClassName} />
                </div>
                <div className={optionsWrapper}>
                    <Scrollbars autoHeight autoHeightMax='11rem'>
                        {filteredOptions.map(option => (
                            <div
                                className={styles.option}
                                key={option.label}
                                onClick={e => {
                                    inputRef.current.focus();
                                    onChange([...selected, option.value]);
                                    setVisibleOptions(false);
                                    onBlur();
                                }}
                            >
                                {option.label}
                            </div>
                        ))}
                    </Scrollbars>
                </div>
            </OutsideClickHandler>
            {error && <div className={cn(styles.error)}>{error}</div>}
            <div className={selectedWrapper}>
                {selected.map(item => {
                    return (
                        <div className={styles.selected} key={item}>
                            <span>{getName(item, t)}</span>
                            <ClearIcon
                                className={styles.selectedButton}
                                onClick={() => {
                                    onChange([...selected.filter(option => option !== item)]);
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

MultiSelect.defaultProps = {
    onBlur: _.noop,
    getName: value => value,
};

export default MultiSelect;
